import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();
  private currentUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public currentUrl$: Observable<string> = this.currentUrl.asObservable();

  setPreviousUrl(previousUrl: string): void {
    this.previousUrl.next(previousUrl);
  }

  setCurrentUrl(currentUrl: string): void {
    this.currentUrl.next(currentUrl);
  }
}
